module.exports = __webpack_public_path__ + "img/bell_curve_stanine.9858ad82.png";